<template>
  <div id="wrapper" :class="pageType">
    <div id="bgr"></div>
    <transition name="fade">
      <div class="loader la-timer" v-if="!componentLoaded">
        <div></div>
      </div>
    </transition>
    <div id="app">
      <div id="logo">
        <a href="/">
          <img
            alt="WDR4 Lieblingsticket Logo"
            src="./assets/wdr4-tickets.svg"
          />
        </a>
      </div>
      <div id="introduction">
        Hier finden Sie alle Veranstaltungen, die WDR 4 veranstaltet oder
        präsentiert.<br />
        Suchen Sie in den einzelnen Rubriken oder ganz individuell mit Ihrem
        Suchbegriff. Viel Spaß!
      </div>
      <transition name="fade" mode="out-in">
        <router-view
          @loaded="isComponentLoaded"
          :key="$route.name"
        ></router-view>
      </transition>
    </div>

    <div id="footer">
      <ul>
        <li>
          <router-link to="/agb">AGB</router-link>
        </li>
        <li>
          <router-link to="/impressum">Impressum</router-link>
        </li>
        <li>
          <router-link to="/datenschutz">Datenschutz</router-link>
        </li>
      </ul>
      <p>
        <small>&copy; WDR mediagroup GmbH {{ date }}</small>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    this.$router.beforeEach((to, from, next) => {
      if (to.query.suche && from.query.suche !== to.query.suche) {
        this.isComponentLoaded("start");
        this.$router.go();
      } else {
        this.componentLoaded = false;
      }
      next();
    });
  },
  data() {
    return {
      componentLoaded: false,
      pageType: "start",
      date: new Date().getFullYear(),
    };
  },
  methods: {
    isComponentLoaded(pageType) {
      this.componentLoaded = true;
      this.pageType = pageType;
    },
  },
};
</script>

<style>
@import "./assets/timer.min.css";

@font-face {
  font-family: Thesis;
  src: url(assets/TheSans_LT_TT5_.eot#);
  src: url(assets/TheSans_LT_TT5_.woff) format("woff"),
    url(assets/TheSans_LT_TT5_.svg) format("svg");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: Thesis;
  src: url(assets/TheSans_LT_TT7_.eot#);
  src: url(assets/TheSans_LT_TT7_.woff) format("woff"),
    url(assets/TheSans_LT_TT7_.svg) format("svg");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: Thesis;
  src: url(assets/TheSans_LT_TT5i.eot#);
  src: url(assets/TheSans_LT_TT5i.woff) format("woff"),
    url(assets/TheSans_LT_TT5i.svg) format("svg");
  font-weight: 400;
  font-style: italic;
}

button {
  cursor: pointer;
}

#wrapper,
button,
input {
  font-family: Thesis, Arial, Helvetica, sans-serif !important;
}

#bgr {
  background-image: url(./assets/hg-wdr-vier-100__v-HintergrundXL.jpg);
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  position: fixed;
}

#logo {
  text-align: left;
  margin-left: 0.75rem;
}
#logo img {
  width: 220px;
}

#introduction {
  color: #474747;
  padding: 1rem 0.8334rem 0;
}

#app {
  font-size: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 2rem 1rem 10rem;
  position: relative;
  box-sizing: border-box;
}

#app .container .filter,
#app .container .eventGroup,
#app .page {
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
}

#app .list {
  margin-top: 0;
}

#app .list a {
  border-bottom: 1px solid rgba(0, 0, 0, 0);
  transition: border-bottom 500ms;
}
#app .list a:hover,
#app .list a:focus {
  border-bottom: 1px solid rgba(0, 0, 0, 1);
}

#app .page {
  padding: 1rem;
  margin-top: 1rem;
}

#app .eventGroup {
  padding-top: 1rem;
  padding-bottom: 0rem;
}

#app .eventGroup figure {
  width: 50%;
  max-width: 350px;
}

#app .filter {
  margin-bottom: 1.5rem;
  padding-bottom: 0;
  padding-top: 0;
}

#app .filter ul {
  width: 100%;
  margin-top: 1rem;
}

#app .filter ul button {
  font-size: 87.5%;
  display: block;
}

#app .filter li {
  width: calc(20% - 2rem);
  vertical-align: top;
  margin: 0 1rem 0.5rem 1rem;
}

#app .filter li figure {
  border-radius: 50%;
  overflow: hidden;
  width: 60%;
  height: 0;
  padding-bottom: 60%;
  position: relative;
  margin-bottom: 0.5rem;
}

#app .filter li img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  left: 0;
}

#app .filter li.active button {
  position: relative;
}

#app .filter li.active button:before {
  content: "\2715";
  display: block;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  background-color: #f4a018;
  color: #000;
  position: absolute;
  right: 20%;
  top: 0;
  line-height: 22px;
  text-align: center;
  font-size: 14px;
  z-index: 1000;
}

#app .container .list {
  padding: 0;
}

#app .list > p {
  padding: 1rem;
}

#app .list .date {
  width: 100px;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

#app .list .date .day {
  font-size: 28px;
  color: #ae650c;
  display: block;
  line-height: 1;
}
#app .list .date .month-year {
  font-weight: bold;
  color: #ae650c;
  display: block;
  font-size: 100%;
  margin-bottom: 0.5rem;
}
#app .list .date .time {
  font-size: 87.5%;
}

#app .list p {
  border: 0 none;
  background-color: #fff;
  margin-top: 0.5rem;
  padding-right: 3rem;
  width: 100%;
  box-sizing: border-box;
}

#app .list p:first-child {
  margin-top: 0;
}

#app .list p span.title img {
  height: 20px;
}

#app .list p span.hint {
  font-style: normal;
}

#app .list .info {
  display: inline-block;
  margin-left: 1rem;
  vertical-align: top;
  width: calc(100% - 280px);
}

#app .list .location {
  font-size: 87.5%;
  display: block;
  margin-top: 0.3rem;
  margin-bottom: 0.8rem;
}

#app .list .title {
  display: block;
  font-weight: bold;
  font-size: 112.5%;
  color: #474747;
}

#app .list a {
  display: inline-block;
  vertical-align: middle;
  background-color: #f4a018;
  color: #000;
  padding: 0.5rem 1rem;
  position: relative;
  margin: 5px 0 0 0;
  border: 0 none;
}

#app .list a:hover,
#app .list a:focus {
  background-color: rgba(244, 160, 24, 0.8);
  border: 0 none;
}

#app .list p span.location img {
  height: 20px;
}

#app .search {
  right: 1rem;
  top: -8.1334rem;
}

#app .search input {
  text-align: left;
  padding: 0.75rem 2.5rem 0.75rem 0;
}

#app .searchField {
  background-color: transparent;
}

#app .searchField:before {
  right: 0;
  margin-top: 9px;
  margin-right: 9px;
}

#app .searchField button {
  right: 8px;
  margin-top: 9px;
}

#app .searchField button:before {
  background-color: #f4a018;
  color: #000;
}

#app .search .mobile-toggle.active:before {
  content: "\2715";
}
#app .search .mobile-toggle:focus {
  outline: 0 none;
}

#footer {
  margin: 0;
  background-color: #fff;
  padding: 2rem;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
}
#footer ul li a,
#footer p {
  color: #000;
}
#footer ul {
  list-style: none;
  display: inline-block;
  margin: 0;
  padding: 0;
}
#footer li {
  display: inline-block;
  margin: 0 1rem;
}
#footer a {
  text-decoration: none;
}
#footer p {
  display: inline-block;
  float: right;
  margin: 0;
}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(244, 160, 24, 0.8);
  z-index: 99999;
  color: #000;
}

.loader > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) scale(3);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-slow-enter-active,
.fade-slow-leave-active {
  transition: opacity 1.5s;
}
.fade-slow-enter, .fade-slow-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (max-width: 640px) {
  #app {
    padding: 1.5rem 1.5rem 10rem;
  }
  #introduction {
    display: none;
  }
  #logo {
    margin-left: 0.3334rem;
  }
  #logo img {
    width: 180px;
    margin-left: 0.5rem;
  }
  #app .search .mobile-toggle {
    top: -4.5rem;
    right: 0;
  }
  #app .filter {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  #footer {
    text-align: center;
    position: relative;
  }
  #footer ul,
  #footer p {
    display: block;
    float: none;
  }
  #footer p {
    margin-top: 2rem;
  }
}
@media screen and (max-width: 820px) {
  #app .container .filter li.image {
    width: calc(25% - 2rem);
  }
}

@media screen and (max-width: 640px) {
  #app {
    padding: 1.5rem 1.5rem 10rem;
  }
  #logo {
    margin-left: 0.333rem;
  }
  #logo img {
    width: 180px;
    margin-left: 0.5rem;
  }

  #app .search .mobile-toggle {
    top: -5.5rem;
  }

  #app .searchField {
    background-color: transparent;
  }

  #app .searchField:before {
    right: 1rem;
    margin-top: 12px;
  }

  #app .search input {
    margin-bottom: 1rem;
  }

  #app .searchField button {
    right: 1rem;
    margin-right: 8px;
    margin-top: 10px;
  }

  #app .container .list p {
    padding-right: 1rem;
  }
  #app .container .list p a {
    transform: translate(0, 0);
    float: none;
  }
  #app .container .list .info {
    width: calc(100% - 163px);
  }
  #app .filter ul {
    margin-left: 0;
  }
  #app .container .filter li.image {
    width: calc(33.333% - 2rem);
  }
  #footer {
    text-align: center;
    position: relative;
  }
  #footer ul,
  #footer p {
    display: block;
    float: none;
  }
  #footer p {
    margin-top: 2rem;
  }
}
@media screen and (max-width: 480px) {
  #app .container .filter li.image {
    width: calc(50% - 2rem);
  }
}
</style>
